const faqs = [
  { q: '是否需要注册才能观看？', a: '不需要。桃子影院所有影视内容均无需注册登录即可直接在线观看，打开网站就能立即追剧，真正做到即点即看。' },
  { q: '视频画质怎么样？支持哪些清晰度？', a: '平台提供从高清720P到蓝光4K的多种画质选择。采用先进的视频编码技术，根据您的网络环境智能匹配最佳画质，确保流畅观影体验。' },
  { q: '观看会卡顿吗？需要缓冲多久？', a: '我们部署了全球CDN加速节点，绝大多数地区可实现秒开播放。即便在网络状况一般的情况下，智能缓冲技术也能保证观影不中断。' },
  { q: '需要付费吗？有没有隐藏收费？', a: '桃子影院承诺永久免费，全站所有影视内容均可无限制免费观看。我们不设置任何付费墙、会员专享或按集收费，真正做到开放共享。' },
  { q: '支持哪些设备观看？', a: '全面支持电脑、手机、平板等主流设备。网页端自适应各种屏幕尺寸，无需下载额外软件，浏览器打开即可享受高清观影。' },
  { q: '剧集更新频率如何？', a: '热门剧集实现每日同步更新，国产剧、韩剧、美剧等均在播出后第一时间上线。我们保持每日50+部剧集的更新速度，确保您不会错过任何精彩内容。' },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
          常见问题
        </h2>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.q}</h3>
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-500 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-5 h-5 items-center justify-center text-primary-500 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}